import { render, staticRenderFns } from "./SidebarContent.vue?vue&type=template&id=29d37d6d&scoped=true"
import script from "./SidebarContent.vue?vue&type=script&lang=ts"
export * from "./SidebarContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d37d6d",
  null
  
)

export default component.exports